// Home é um módulo removível. Grants amplos somente de leitura não podem
// recriá-lo; o god-mode administrativo (`all:manage`) continua válido.
export const hasExplicitModuleAccess = (action, subject, rules = []) => (
  Array.isArray(rules) && rules.some((rule) => (
    (rule.subject === subject && (rule.action === action || rule.action === 'manage'))
    || (rule.subject === 'all' && rule.action === 'manage')
  ))
);

export const permissionRefreshContext = (token, perfilId) => (
  token && perfilId != null ? `${token}:${perfilId}` : null
);

export const shouldRefreshPermissions = (lastContext, context, force = false) => (
  !!context && (force || lastContext !== context)
);

// Retorna null para qualquer resposta incompleta/de outro perfil. O chamador
// trata null como falha fechada ao navegar diretamente para Home.
export const synchronizeCanonicalHome = (currentRules, activeProfile, perfilId) => {
  if (!activeProfile || Number(activeProfile.id_perfil_acesso) !== Number(perfilId)) return null;
  const current = Array.isArray(currentRules) ? currentRules : [];
  const canonical = Array.isArray(activeProfile.Permissoes) ? activeProfile.Permissoes : [];
  return [
    ...current.filter((rule) => !['Home', 'AssistenciaTecnica'].includes(rule.subject)),
    ...canonical.filter((rule) => ['Home', 'AssistenciaTecnica'].includes(rule.subject)),
  ];
};